import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import styles from "./styles.module.css";
import { useTheme } from "../../../../../context/themeContext";
import { useSelector } from "react-redux";

const UserLocation = () => {
  const { theme, darkMode } = useTheme();
  const user = useSelector((state) => state.user.value);

  const userLocaton = [
    {
      label: "Country",
      value: user.country,
      isEmpty: user.country === null ? true : false,
    },
    {
      label: "Postal Code",
      value: user.postalCode,
      isEmpty: user.postalCode.length === 0,
    },
    {
      label: "City, State, County",
      value: user?.city + ", " + user?.state + ", " + user?.county,
      isEmpty: user.city.length + user.state.length + user.county.length === 0,
    },
  ];

  return (
    <Box
      className={styles.communityStatus}
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.darkgrey.darkgrey600,
          fontSize: "18px",
          fontWeight: 700,
        }}
      >
        My Location
      </Typography>

      <Box className={styles.content}>
        {userLocaton.map((item) => (
          <Box key={item.label} className={styles.same}>
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.darkgrey.darkgrey300,
              }}
            >
              {item.label}
            </Typography>
            {item.label === "Country"
              ? !item.isEmpty && (
                  <Chip
                    label={item.value}
                    sx={{
                      color: darkMode
                        ? theme.palette.secondary.blue100
                        : theme.palette.secondary.blue700,
                      bgcolor: !darkMode && theme.palette.secondary.light,
                      fontWeight: 500,
                      fontSize: "14px",
                      height: "32px",
                      "& .css-6od3lo-MuiChip-label": {
                        padding: "0px 16px",
                      },
                    }}
                  />
                )
              : item.label === "Postal Code"
              ? !item.isEmpty && (
                  <Box className={styles.detail}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: darkMode
                          ? theme.palette.darkgrey.darkgreybody50
                          : theme.palette.darkgrey.darkgrey600,
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                )
              : !item.isEmpty && (
                  <Typography
                    variant="body1"
                    sx={{
                      color: darkMode
                        ? theme.palette.darkgrey.darkgreybody50
                        : theme.palette.darkgrey.darkgrey600,
                    }}
                  >
                    {item.value}
                  </Typography>
                )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default UserLocation;
